import { Component } from '@angular/core';

@Component({
  selector: 'products-component',
  templateUrl: './products.tpl.html'
})
export class ProductsComponent {
  products:any[];
  constructor(){
  	this.products =[{
	"name":"testo-175 T3 Temperature logger",
	"tagline":"Order-Nr. 0572 1753",
	"image_url":"testo-175T3-instrument-temperature-001869-bear_master.jpg",
	"url":"",
	"description":"The temperature logger testo 175 T3 with its two external thermocouple probes is best suited when for recording temperatures at two locations in parallel: for example when measuring the flow and return temperature on radiators.Very large temperature measuring range from -50 °C to +1,000 °C."
	},{
	"name":"testo 174 T - Mini temperature data logger",
	"tagline":"Order-Nr. 0572 1560",
	"image_url":"testo-174T-p-in-tem-001890_prl.jpg",
	"url":"",
	"description":"The mini temperature data logger testo 174T is ideal for continuous monitoring of storage temperature, for example of food or pharmaceutical products. It is also suitable for temperature control in refrigerators or cold stores.."
	},{
	"name":"testo 176 T4 - Temperature data logger",
	"tagline":"Order-Nr. 0572 1764",
	"image_url":"testo-176T4-p-in-tem-001868_prl.jpg",
	"url":"",
	"description":"The testo 176 T4 temperature data logger can measure the temperature at upto four different measurement sites simultaneously. It has a super size memory for upto 2,000,000 readings and is compatible with a number of different thermocouples making it ideal for professional use in a variety of fields."
	},{
	"name":"testo 175 T1 - Single Channel Temperature data logger",
	"tagline":"Order-Nr. 0572 1751",
	"image_url":"testo-175T1-p-in-tem-001857_prl.jpg",
	"url":"",
	"description":"The testo 175 T1 temperature data logger is ideal for monitoring storage temperatures and long-term monitoring. It is certified for use in food environments and measures and logs temperatures constantly and reliably."
	},{
	"name":"testo 175 T2 - Two Channel Temperature data logger",
	"tagline":"0572 1752",
	"image_url":"testo-175T2-p-in-tem-001858_prl.jpg",
	"url":"",
	"description":"The temperature data logging with testo 175 T2 is ideally suited if you want to use single instrument to monitor air temperature and at the same time record additional temperature value on a second channel. It suits best for food storage for parallel temperature control of ambient conditions and the goods themselves."
	},{
	"name":"testo 176 T2 - Temperature data logger",
	"tagline":"Order-Nr. 0572 1762",
	"image_url":"testo-176T2-p-in-tem-001870_prl.jpg",
	"url":"",
	"description":"With two inputs for external Pt100 probes, testo 176 T2 temperature data logger can record temperature at two measuring points simultaneously. It means that it can monitor temperature at different locations in parallel. The temperature logger has a large display for optimum presentation of the readings."
	}];
  }
}



// WEBPACK FOOTER //
// ./src/app/products/products.component.ts